import { format, formatDistanceToNow, type FormatDistanceToNowOptions } from 'date-fns';
import { ar, enUS } from 'date-fns/locale';

export function getDateFnsLocale(language?: string) {
  return language?.toLowerCase().startsWith('ar') ? ar : enUS;
}

export function formatRelativeTime(
  date: Date | string | number,
  language?: string,
  options: Omit<FormatDistanceToNowOptions, 'locale'> = { addSuffix: true },
) {
  return formatDistanceToNow(new Date(date), {
    ...options,
    locale: getDateFnsLocale(language),
  });
}

export function formatLocalizedDate(date: Date | string | number, pattern: string, language?: string) {
  return format(new Date(date), pattern, { locale: getDateFnsLocale(language) });
}
